// A tela de bloqueio se libera sozinha (dono, 03/10/2026).
//
// Quem lia o QR com o caixa fechado ficava parado no aviso — ou saía pelo
// botão "VER O CARDÁPIO", que levava ao cardápio online, e pedia retirada
// achando que era a mesa (Mestre dos Jogos, pedido #23092). O botão saiu; em
// troca, enquanto o aviso estiver na tela o celular pergunta de novo e, quando
// o motivo acaba, mostra o que uma leitura nova do QR mostraria.
import { useEffect, useRef } from "react";

// A primeira pergunta sai logo: sessão encerrada libera já nela, e dá tempo
// de ler o aviso antes de a tela trocar.
const PRIMEIRA_MS = 2500;
const INTERVALO_MS = 8000;
// Aviso há muito tempo na tela é celular esquecido aberto: pergunta menos.
const INTERVALO_LONGO_MS = 30000;
const LONGO_DEPOIS_MS = 10 * 60 * 1000;
const AO_VOLTAR_MS = 300;

// `conferir(vivo)` pergunta o estado da mesa e troca a tela se ele mudou.
export function useBloqueioSeLibera({ ativo, conferir }) {
  const conferirAgora = useRef(conferir);
  conferirAgora.current = conferir;

  useEffect(() => {
    if (!ativo) return undefined;
    let vivo = true;
    let timer = null;
    let perguntando = false;
    const inicio = Date.now();

    const agendar = (ms) => {
      clearTimeout(timer);
      timer = setTimeout(perguntar, ms);
    };
    const perguntar = async () => {
      // Celular bloqueado ou em outra aba não pergunta: volta no visibilitychange
      if (!vivo || perguntando || document.hidden) return;
      perguntando = true;
      try {
        await conferirAgora.current(() => vivo);
      } finally {
        perguntando = false;
      }
      if (vivo) agendar(Date.now() - inicio > LONGO_DEPOIS_MS ? INTERVALO_LONGO_MS : INTERVALO_MS);
    };
    const aoVoltar = () => { if (!document.hidden) agendar(AO_VOLTAR_MS); };

    agendar(PRIMEIRA_MS);
    document.addEventListener("visibilitychange", aoVoltar);
    return () => {
      vivo = false;
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", aoVoltar);
    };
  }, [ativo]);
}
